import type { IconProps } from '../components/IconSvg';
import { IconSvg } from '../components/IconSvg';

export function MinusAlt(props: IconProps) {
  return (
    <IconSvg {...props}>
      <polygon points="2 21.4308617 2 15.0180361 14.6332665 15.0180361 21.3026052 15.0180361 34 15.0180361 34 21.4308617"></polygon>
    </IconSvg>
  );
}
